import React from 'react';
import { useNavigate } from 'react-router-dom';

const ElbowForearmPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .elbow-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #e0f2fe 0, #f9fafb 45%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .elbow-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO – centered, different from others */
        .elbow-hero {
          text-align: center;
          padding: 24px 18px 30px;
          border-radius: 26px;
          background: linear-gradient(135deg, rgba(37, 99, 235, 0.12), rgba(59, 130, 246, 0.03));
          margin-bottom: 30px;
        }

        .elbow-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(37, 99, 235, 0.16);
          color: #1d4ed8;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 10px;
        }

        .elbow-tag-dot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #1d4ed8;
        }

        .elbow-title {
          font-size: clamp(27px, 4vw, 36px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 10px;
        }

        .elbow-subtitle {
          font-size: 15px;
          max-width: 620px;
          margin: 0 auto;
          line-height: 1.5;
          color: #1f2937;
        }

        .elbow-heroChips {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 8px;
          margin: 14px 0 16px;
        }

        .elbow-chip {
          padding: 6px 11px;
          border-radius: 999px;
          background: rgba(15, 23, 42, 0.92);
          color: #f9fafb;
          font-size: 11px;
        }

        .elbow-ctaRow {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 10px;
          margin-top: 8px;
        }

        .elbow-btnPrimary,
        .elbow-btnSecondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
        }

        .elbow-btnPrimary {
          background: #2563eb;
          color: #f9fafb;
          box-shadow: 0 9px 22px rgba(37, 99, 235, 0.35);
        }

        .elbow-btnPrimary:hover {
          transform: translateY(-1px);
          box-shadow: 0 12px 28px rgba(37, 99, 235, 0.45);
        }

        .elbow-btnSecondary {
          background: rgba(15, 23, 42, 0.04);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.7);
        }

        .elbow-btnSecondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .elbow-heroSmall {
          font-size: 11px;
          margin-top: 10px;
          color: #6b7280;
        }

        .elbow-heroImageWrap {
          margin-top: 18px;
          display: flex;
          justify-content: center;
        }

        .elbow-heroImage {
          width: 100%;
          max-width: 420px;
          border-radius: 24px;
          object-fit: cover;
          box-shadow: 0 18px 38px rgba(15, 23, 42, 0.28);
        }

        /* STRIPES / SECTIONS */
        .elbow-stripe {
          padding: 28px 0;
          border-bottom: 1px solid rgba(148, 163, 184, 0.45);
        }

        .elbow-sectionTitle {
          font-size: 19px;
          font-weight: 700;
          margin-bottom: 8px;
        }

        .elbow-sectionSubtitle {
          font-size: 13px;
          color: #4b5563;
          margin-bottom: 14px;
        }

        .elbow-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 22px;
          align-items: center;
        }

        .elbow-flexCol {
          flex: 1 1 260px;
        }

        .elbow-inlineImage {
          width: 100%;
          max-width: 360px;
          border-radius: 22px;
          object-fit: cover;
          box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);
        }

        .elbow-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 7px;
        }

        .elbow-list li {
          display: flex;
          gap: 8px;
          font-size: 14px;
          color: #111827;
        }

        .elbow-bullet {
          width: 7px;
          height: 7px;
          border-radius: 999px;
          margin-top: 6px;
          background: #2563eb;
          flex-shrink: 0;
        }

        /* 3-CARD STRIP FOR FLEXORS / EXTENSORS / BRACHIORADIALIS */
        .elbow-triplet {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 16px;
          margin-top: 16px;
        }

        .elbow-tile {
          padding: 11px 13px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.02);
          border: 1px solid rgba(148, 163, 184, 0.5);
        }

        .elbow-tileTitle {
          font-size: 13px;
          font-weight: 600;
          margin-bottom: 4px;
        }

        .elbow-tileText {
          font-size: 12px;
          color: #4b5563;
        }

        /* TIMELINE / VISIT FLOW */
        .elbow-timeline {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 10px;
          margin-top: 12px;
        }

        .elbow-step {
          border-radius: 18px;
          padding: 10px 12px;
          background: rgba(15, 23, 42, 0.03);
        }

        .elbow-stepLabel {
          font-size: 12px;
          font-weight: 600;
          margin-bottom: 4px;
        }

        .elbow-stepText {
          font-size: 12px;
          color: #4b5563;
        }

        /* FULL-WIDTH BANNER */
        .elbow-banner {
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          margin-top: 18px;
        }

        .elbow-banner img {
          width: 100%;
          height: 220px;
          object-fit: cover;
          display: block;
        }

        @media (min-width: 768px) {
          .elbow-banner img {
            height: 260px;
          }
        }

        .elbow-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.78), transparent 55%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 8px;
        }

        .elbow-bannerText {
          color: #e5e7eb;
          font-size: 15px;
          max-width: 420px;
        }

        .elbow-bannerButtons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 6px;
        }

        .elbow-bannerButtons button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .elbow-bannerButtons .primary {
          background: #22c55e;
          color: #022c22;
        }

        .elbow-bannerButtons .secondary {
          background: rgba(15, 23, 42, 0.35);
          color: #f9fafb;
          border: 1px solid rgba(209, 213, 219, 0.7);
        }

        /* BOTTOM WARNING STRIP */
        .elbow-bottomStrip {
          margin-top: 24px;
          padding: 14px 14px;
          border-radius: 22px;
          background: #0f172a;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          align-items: center;
          justify-content: space-between;
        }

        .elbow-bottomText {
          font-size: 12px;
          color: #e5e7eb;
          flex: 1 1 240px;
        }

        .elbow-bottomText strong {
          color: #fef9c3;
        }

        .elbow-bottomActions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .elbow-bottomActions button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .elbow-bottomActions .primary {
          background: #2563eb;
          color: #f9fafb;
        }

        .elbow-bottomActions .secondary {
          background: transparent;
          color: #e5e7eb;
          border: 1px solid rgba(148, 163, 184, 0.8);
        }

        @media (max-width: 640px) {
          .elbow-title {
            font-size: 25px;
          }
        }
      `}</style>

      <div className="elbow-page">
        <div className="elbow-inner">
          {/* ===== HERO ===== */}
          <section className="elbow-hero">
            <div className="elbow-tag">
              <span className="elbow-tag-dot" />
              Elbow & Forearm Relief
            </div>
            <h1 className="elbow-title">
              Reduce elbow & forearm pain so gripping, lifting, and typing feel possible again.
            </h1>
            <p className="elbow-subtitle">
              The elbow joint, forearm flexors, extensors, and brachioradialis work together for
              gripping, typing, lifting, and everyday tasks. When they&apos;re irritated, simple
              movements can feel sharp, burning, or achy.
            </p>

            <div className="elbow-heroChips">
              <span className="elbow-chip">Pain with gripping or lifting</span>
              <span className="elbow-chip">Tennis elbow / golfer&apos;s elbow</span>
              <span className="elbow-chip">Forearm tightness with typing</span>
              <span className="elbow-chip">Soreness after workouts or tools</span>
            </div>

            <div className="elbow-ctaRow">
              <button
                className="elbow-btnPrimary"
                onClick={() => navigate('/appointments')}
              >
                Book an elbow & forearm visit →
              </button>
              <button
                className="elbow-btnSecondary"
                onClick={() => navigate('/staff')}
              >
                Meet our therapists
              </button>
            </div>

            <p className="elbow-heroSmall">
              You don&apos;t have to give up lifting, sports, or work tasks forever. PT can help
              calm things down and rebuild gradually.
            </p>

            <div className="elbow-heroImageWrap">
              <img
                src="/content/elbow-forearm/elbow_forearm_hero.jpg"
                alt="Therapist assessing a patient’s elbow and forearm"
                className="elbow-heroImage"
              />
            </div>
          </section>

          {/* ===== STRIPE 1 – WHAT CAN GO WRONG ===== */}
          <section className="elbow-stripe">
            <div className="elbow-sectionTitle">What can go wrong in the elbow & forearm?</div>
            <p className="elbow-sectionSubtitle">
              The elbow sits between the upper arm and forearm, with flexors on the inner forearm,
              extensors on the outer forearm, and brachioradialis on top. Any of them can flare up.
            </p>

            <div className="elbow-flexRow">
              <div className="elbow-flexCol">
                <ul className="elbow-list">
                  <li>
                    <span className="elbow-bullet" />
                    <span>
                      <strong>Elbow joint irritation:</strong> pain with bending, straightening, or
                      pushing up from a chair or floor.
                    </span>
                  </li>
                  <li>
                    <span className="elbow-bullet" />
                    <span>
                      <strong>Forearm flexor overuse:</strong> inner forearm pain, often linked to
                      gripping, typing, or “golfer&apos;s elbow.”
                    </span>
                  </li>
                  <li>
                    <span className="elbow-bullet" />
                    <span>
                      <strong>Forearm extensor strain:</strong> outer forearm pain with lifting,
                      tools, or “tennis elbow” type symptoms.
                    </span>
                  </li>
                  <li>
                    <span className="elbow-bullet" />
                    <span>
                      <strong>Brachioradialis tension:</strong> pain on the top of the forearm,
                      especially with lifting something like a jug or bag.
                    </span>
                  </li>
                  <li>
                    <span className="elbow-bullet" />
                    <span>
                      <strong>Nerve irritation:</strong> tingling or numbness in the forearm or hand
                      that may be related to elbow position.
                    </span>
                  </li>
                </ul>

                <div className="elbow-ctaRow" style={{ marginTop: '14px', justifyContent: 'flex-start' }}>
                  <button
                    className="elbow-btnPrimary"
                    onClick={() => navigate('/appointments')}
                  >
                    See if your elbow/forearm symptoms fit →
                  </button>
                  <button
                    className="elbow-btnSecondary"
                    onClick={() => navigate('/contact')}
                  >
                    Ask a quick question
                  </button>
                </div>
              </div>

              <div className="elbow-flexCol" style={{ display: 'flex', justifyContent: 'center' }}>
                <img
                  src="/content/elbow-forearm/elbow_flexors.jpg"
                  alt="Therapist treating the inner forearm flexor muscles"
                  className="elbow-inlineImage"
                />
              </div>
            </div>

            <div className="elbow-triplet">
              <div className="elbow-tile">
                <div className="elbow-tileTitle">Forearm flexors</div>
                <div className="elbow-tileText">
                  Inner forearm muscles that help you grip, type, and hold objects — often irritated
                  by repetitive use.
                </div>
              </div>
              <div className="elbow-tile">
                <div className="elbow-tileTitle">Forearm extensors</div>
                <div className="elbow-tileText">
                  Outer forearm muscles that stabilize the wrist and help with lifting, tools, and
                  racket sports.
                </div>
              </div>
              <div className="elbow-tile">
                <div className="elbow-tileTitle">Brachioradialis</div>
                <div className="elbow-tileText">
                  Runs along the top of the forearm; works hard when you lift things with a
                  handshake-type grip.
                </div>
              </div>
            </div>
          </section>

          {/* ===== STRIPE 2 – HOW PT HELPS (MANUAL + LOAD) ===== */}
          <section className="elbow-stripe">
            <div className="elbow-flexRow">
              <div className="elbow-flexCol" style={{ order: 2 }}>
                <div className="elbow-sectionTitle">How physical therapy helps the elbow & forearm</div>
                <p className="elbow-sectionSubtitle">
                  We calm irritated tissue, guide load back in slowly, and help you use the arm in
                  ways that support healing instead of fighting it.
                </p>

                <ul className="elbow-list">
                  <li>
                    <span className="elbow-bullet" />
                    <span>
                      <strong>Joint mobilization:</strong> gentle movement at the elbow joint to
                      restore comfortable bending and straightening.
                    </span>
                  </li>
                  <li>
                    <span className="elbow-bullet" />
                    <span>
                      <strong>Soft-tissue work:</strong> focused treatment to flexors, extensors,
                      and brachioradialis to reduce tight, “ropey” areas.
                    </span>
                  </li>
                  <li>
                    <span className="elbow-bullet" />
                    <span>
                      <strong>Load progression:</strong> using light resistance and graded exercises
                      to re-build tolerance without flaring things up.
                    </span>
                  </li>
                  <li>
                    <span className="elbow-bullet" />
                    <span>
                      <strong>Grip and wrist mechanics:</strong> teaching positions and techniques
                      that reduce strain during work, sports, or workouts.
                    </span>
                  </li>
                  <li>
                    <span className="elbow-bullet" />
                    <span>
                      <strong>Home plan that fits:</strong> a few focused moves you can repeat,
                      not a giant list that&apos;s easy to ignore.
                    </span>
                  </li>
                </ul>

                <div className="elbow-ctaRow" style={{ marginTop: '14px', justifyContent: 'flex-start' }}>
                  <button
                    className="elbow-btnPrimary"
                    onClick={() => navigate('/appointments')}
                  >
                    Start with one elbow/forearm session →
                  </button>
                  <button
                    className="elbow-btnSecondary"
                    onClick={() => navigate('/insurance')}
                  >
                    Check my insurance
                  </button>
                </div>
              </div>

              <div className="elbow-flexCol" style={{ order: 1, display: 'flex', justifyContent: 'center' }}>
                <img
                  src="/content/elbow-forearm/elbow_extensors.jpg"
                  alt="Therapist working on the outer forearm extensor muscles"
                  className="elbow-inlineImage"
                />
              </div>
            </div>
          </section>

          {/* ===== STRIPE 3 – VISIT FLOW + EXERCISES ===== */}
          <section className="elbow-stripe">
            <div className="elbow-flexRow">
              <div className="elbow-flexCol">
                <img
                  src="/content/elbow-forearm/elbow_exercises.jpg"
                  alt="Patient performing elbow and forearm exercises with guidance"
                  className="elbow-inlineImage"
                />
              </div>

              <div className="elbow-flexCol">
                <div className="elbow-sectionTitle">What an elbow & forearm visit may look like</div>
                <p className="elbow-sectionSubtitle">
                  Sessions stay focused and clear so you always know why you&apos;re doing each
                  exercise or technique.
                </p>

                <div className="elbow-timeline">
                  <div className="elbow-step">
                    <div className="elbow-stepLabel">1. Your story</div>
                    <div className="elbow-stepText">
                      You share where it hurts, what triggers it (gripping, typing, tools, sports),
                      and what you want to return to.
                    </div>
                  </div>
                  <div className="elbow-step">
                    <div className="elbow-stepLabel">2. Motion & strength check</div>
                    <div className="elbow-stepText">
                      We look at elbow motion, wrist motion, grip strength, and forearm muscle
                      tenderness.
                    </div>
                  </div>
                  <div className="elbow-step">
                    <div className="elbow-stepLabel">3. Hands-on care</div>
                    <div className="elbow-stepText">
                      You try targeted manual work or stretches to see what gives relief.
                    </div>
                  </div>
                  <div className="elbow-step">
                    <div className="elbow-stepLabel">4. Simple home plan</div>
                    <div className="elbow-stepText">
                      You leave with a short, repeatable plan and clear “green light / yellow light”
                      guidelines.
                    </div>
                  </div>
                </div>

                <div className="elbow-ctaRow" style={{ marginTop: '14px', justifyContent: 'flex-start' }}>
                  <button
                    className="elbow-btnPrimary"
                    onClick={() => navigate('/appointments')}
                  >
                    Book an elbow & forearm evaluation →
                  </button>
                  <button
                    className="elbow-btnSecondary"
                    onClick={() => navigate('/contact')}
                  >
                    Talk to our team first
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* ===== BANNER ===== */}
          <section className="elbow-stripe">
            <div className="elbow-banner">
              <img
                src="/content/elbow-forearm/elbow_banner.jpg"
                alt="Bright physical therapy clinic environment for elbow and forearm rehab"
              />
              <div className="elbow-bannerOverlay">
                <div className="elbow-bannerText">
                  Elbow and forearm sessions happen in a calm, one-on-one clinic space where we can
                  adjust everything to your job, sport, and daily life.
                </div>
                <div className="elbow-bannerButtons">
                  <button
                    className="primary"
                    onClick={() => navigate('/appointments')}
                  >
                    Schedule my elbow/forearm visit →
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate('/office')}
                  >
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* ===== BOTTOM WARNING ===== */}
          <section className="elbow-stripe">
            <div className="elbow-bottomStrip">
              <div className="elbow-bottomText">
                If you have a sudden injury with a loud pop, significant swelling, deformity,
                or can&apos;t move or use the arm at all,{" "}
                <strong>seek medical or emergency care first.</strong> Physical therapy can then help
                guide your recovery and safe return to activity.
              </div>
              <div className="elbow-bottomActions">
                <button
                  className="primary"
                  onClick={() => navigate('/appointments')}
                >
                  Schedule elbow & forearm PT
                </button>
                <button
                  className="secondary"
                  onClick={() => navigate('/contact')}
                >
                  Message our team
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ElbowForearmPT;
